import i18next, { type i18n } from "i18next";
import { initReactI18next } from "react-i18next";

import en from "@/locales/en.json";
import ro from "@/locales/ro.json";

export function createI18n(locale: string): i18n {
  const instance = i18next.createInstance();
  void instance.use(initReactI18next).init({
    resources: { en: { translation: en }, ro: { translation: ro } },
    lng: locale === "ro" ? "ro" : "en",
    fallbackLng: "en",
    interpolation: { escapeValue: false },
    initAsync: false,
  });
  return instance;
}
